import { render, staticRenderFns } from "./Cartoon.vue?vue&type=template&id=fcca3f02&"
import script from "./Cartoon.vue?vue&type=script&lang=js&"
export * from "./Cartoon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fcca3f02')) {
      api.createRecord('fcca3f02', component.options)
    } else {
      api.reload('fcca3f02', component.options)
    }
    module.hot.accept("./Cartoon.vue?vue&type=template&id=fcca3f02&", function () {
      api.rerender('fcca3f02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/detail/Cartoon.vue"
export default component.exports